import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Sidebar from "../../../../components/ui/sidebar";
import { Card, CardContent, CardHeader, CardTitle } from "../../../../components/ui/card";
import { Button } from "../../../../components/ui/button";
import { Calendar, Plus, Clock, Loader2 } from "lucide-react";
import { useAuth } from "../../../../context/AuthContext";
import CreateDiaHabilModal from "./CreateDiaHabilModal";
import Swal from "sweetalert2";

export default function DiasHabilesZonaComunPage() {
  const { session } = useAuth();
  const { codigo } = useParams<{ codigo: string }>();
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [zonaComunCodigo, setZonaComunCodigo] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Obtener el código de zona común desde la URL
  useEffect(() => {
    if (codigo) {
      setZonaComunCodigo(codigo);
    } else {
      // Si no viene de la URL, intentar obtenerlo de otro lugar
      // Por ejemplo, desde localStorage, contexto, o props
      // setZonaComunCodigo("F69C0BFD"); // Ejemplo del usuario
    }
  }, [codigo]);

  const handleOpenModal = () => {
    if (!zonaComunCodigo || zonaComunCodigo.trim() === "") {
      Swal.fire({
        icon: "warning",
        title: "Código de zona común requerido",
        text: "No se ha especificado el código de zona común. Por favor, asegúrese de acceder a esta página con el código de zona común correcto.",
        confirmButtonColor: "#3d5a40",
        didOpen: (popup) => {
          (popup as HTMLElement).style.zIndex = '10001';
        },
      });
      return;
    }
    setShowCreateModal(true);
  };

  const handleCloseModal = (created: boolean) => {
    setShowCreateModal(false);
    if (created) {
      // Recargar la lista de días hábiles si es necesario
      // loadDiasHabiles();
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-100 text-gray-900">
      <Sidebar />
      <main className="flex-1 p-4 sm:p-6 md:ml-64 transition-all">
        <div className="flex items-center justify-between mb-4 sm:mb-6">
          <h2 className="text-2xl sm:text-3xl font-bold text-military-600">
            Días Hábiles Zona Común
          </h2>
          <Button
            onClick={handleOpenModal}
            className="bg-military-500 hover:bg-military-600 text-white shadow-lg font-semibold flex items-center gap-2"
          >
            <Plus size={20} />
            <span className="hidden sm:inline">Agregar Día Hábil</span>
            <span className="sm:hidden">Agregar</span>
          </Button>
        </div>

        <Card className="shadow-lg border-l-4 border-military-500">
          <CardHeader>
            <div className="flex items-center justify-between">
              <CardTitle className="text-xl text-military-600 flex items-center gap-2">
                <Calendar size={24} />
                Lista de Días Hábiles
              </CardTitle>
              <Button
                onClick={handleOpenModal}
                className="bg-military-500 hover:bg-military-600 text-white shadow-lg font-semibold flex items-center gap-2"
              >
                <Plus size={20} />
                <span className="hidden sm:inline">Nuevo Día Hábil</span>
                <span className="sm:hidden">Nuevo</span>
              </Button>
            </div>
          </CardHeader>
          <CardContent>
            {isLoading ? (
              <div className="flex items-center justify-center py-8">
                <Loader2 className="h-8 w-8 animate-spin text-military-600" />
                <span className="ml-2 text-gray-600">Cargando días hábiles...</span>
              </div>
            ) : (
              <div className="text-center py-8 text-gray-500">
                <Calendar size={48} className="mx-auto mb-4 text-gray-400" />
                <p>No hay días hábiles configurados aún.</p>
                <p className="text-sm mt-2 mb-4">
                  Haz clic en el botón "Nuevo Día Hábil" para agregar uno.
                </p>
                <Button
                  onClick={handleOpenModal}
                  className="bg-military-500 hover:bg-military-600 text-white shadow-lg font-semibold flex items-center gap-2 mx-auto"
                >
                  <Plus size={20} />
                  Agregar Primer Día Hábil
                </Button>
              </div>
            )}
          </CardContent>
        </Card>

        <button
          onClick={handleOpenModal}
          className="fixed bottom-6 right-6 bg-military-500 hover:bg-military-600 text-white rounded-full p-4 shadow-2xl z-50 md:hidden"
          aria-label="Agregar día hábil"
        >
          <Plus size={24} />
        </button>

        <CreateDiaHabilModal
          isOpen={showCreateModal}
          zonaComunCodigo={zonaComunCodigo}
          onClose={handleCloseModal}
        />
      </main>
    </div>
  );
}

